<template>
  <v-card class="card" :class="isMobile ? 'mt-16px' : 'mt-30px'">
    <h2 :class="isMobile ? 'mb-8px' : 'mb-15px'">{{ nazovProduktu }}</h2>

    <!-- #################### -->
    <!-- POPLATKY -->
    <!-- #################### -->
    <template v-if="visiblePoplatky">
      <div v-if="!isMobile" class="f18">Poplatky</div>
      <v-divider class="mt-2" :class="{ 'mb-3': !isMobile }"></v-divider>
      <!-- DESKTOP -->
      <template v-if="!isMobile">
        <v-row class="mt-10px px-12px mx-0px">
          <v-col xl="6" lg="6" md="6" class="pa-0px">
            <span class="f14 gs100 bold">Názov poplatku</span>
          </v-col>
          <v-col xl="2" lg="2" md="2">
            <span class="f14 gs100 right bold" v-show="poplatkyVisiblePerc">Výška v %</span>
          </v-col>
          <v-col xl="2" lg="2" md="2">
            <span class="f14 gs100 right bold" v-show="poplatkyVisibleZakl">Základ</span>
          </v-col>
          <v-col xl="2" lg="2" md="2">
            <span class="f14 gs100 right bold" v-show="poplatkyVisibleSDph">
              {{ jeDealer ? 'Spolu' : 'Cena s DPH' }}</span
            >
          </v-col>
        </v-row>
        <v-row no-gutters class="poplatok-row px-12px mx-0px" v-show="spPoplVisible">
          <v-col xl="6" lg="6" md="6" class="pl-0px">
            <span class="f16">{{ sp_popl.nazov }}</span>
          </v-col>
          <v-col xl="2" lg="2" md="2" class="px-11px">
            <numeric-text-box
              dense
              dynamic
              :parentReloaded="produktFormReloaded"
              ref="sprac_popl_perc"
              @valueChanged="spracPoplPercValueChanged"
              :cisloPlz="cisloPlz"
              dataId="liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_perc"
              :key="'liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_perc' + cisloPlz"
              :cisloPredmetu="cisloPredmetu"
              suffix="%"
              textRight
              hide-details
              hide-label
              :disabled="isCalculating"
              @dataLoaded="visiblePoplatkyHeader('sprac_popl', 'perc')"
              :decimalPlaces="3"
              replaceNull
            ></numeric-text-box>
          </v-col>
          <v-col xl="2" lg="2" md="2" class="px-11px">
            <numeric-text-box
              dense
              dynamic
              :parentReloaded="produktFormReloaded"
              @valueChanged="spracPoplZaklValueChanged"
              ref="sprac_popl_zakl"
              :cisloPlz="cisloPlz"
              dataId="liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_zakl"
              :key="'liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_zakl' + cisloPlz"
              :cisloPredmetu="cisloPredmetu"
              suffix="€"
              textRight
              hide-details
              hide-label
              :disabled="isCalculating || !jeDealer"
              @dataLoaded="visiblePoplatkyHeader('sprac_popl', 'zakl')"
              :decimalPlaces="2"
              replaceNull
            ></numeric-text-box>
          </v-col>
          <v-col xl="2" lg="2" md="2" class="px-11px">
            <numeric-text-box
              dense
              dynamic
              :parentReloaded="produktFormReloaded"
              @valueChanged="spracPoplSDphValueChanged"
              ref="sprac_popl_s_dph"
              :cisloPlz="cisloPlz"
              dataId="liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_s_dph"
              :key="'liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_s_dph' + cisloPlz"
              :cisloPredmetu="cisloPredmetu"
              suffix="€"
              textRight
              hide-details
              hide-label
              :disabled="isCalculating || !jeDealer"
              @dataLoaded="visiblePoplatkyHeader('sprac_popl', 's_dph')"
              :decimalPlaces="2"
              replaceNull
            ></numeric-text-box>
          </v-col>
        </v-row>
        <v-row no-gutters class="poplatok-row-dark poplatok-row px-12px mx-0px" v-show="ukonPoplVisible">
          <v-col xl="6" lg="6" md="6" class="pl-0px">
            <span class="f16">{{ ukon_popl.nazov }}</span>
          </v-col>
          <v-col xl="2" lg="2" md="2" class="px-11px">
            <numeric-text-box
              dense
              dynamic
              :parentReloaded="produktFormReloaded"
              @valueChanged="ukonPoplPercValueChanged"
              ref="ukon_popl_perc"
              :cisloPlz="cisloPlz"
              dataId="liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_perc"
              :key="'liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_perc' + cisloPlz"
              :cisloPredmetu="cisloPredmetu"
              suffix="%"
              textRight
              hide-details
              hide-label
              :disabled="isCalculating"
              @dataLoaded="visiblePoplatkyHeader('ukon_popl', 'perc')"
              :decimalPlaces="3"
              replaceNull
            ></numeric-text-box>
          </v-col>
          <v-col xl="2" lg="2" md="2" class="px-11px">
            <numeric-text-box
              dense
              dynamic
              :parentReloaded="produktFormReloaded"
              @valueChanged="ukonPoplZaklValueChanged"
              ref="ukon_popl_zakl"
              :cisloPlz="cisloPlz"
              dataId="liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_zakl"
              :key="'liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_zakl' + cisloPlz"
              :cisloPredmetu="cisloPredmetu"
              suffix="€"
              textRight
              hide-details
              hide-label
              :disabled="isCalculating || !jeDealer"
              @dataLoaded="visiblePoplatkyHeader('ukon_popl', 'zakl')"
              :decimalPlaces="2"
              replaceNull
            ></numeric-text-box>
          </v-col>
          <v-col xl="2" lg="2" md="2" class="px-11px">
            <numeric-text-box
              dense
              dynamic
              :parentReloaded="produktFormReloaded"
              ref="ukon_popl_s_dph"
              @valueChanged="ukonPoplSDphValueChanged"
              :cisloPlz="cisloPlz"
              dataId="liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_s_dph"
              :key="'liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_s_dph' + cisloPlz"
              :cisloPredmetu="cisloPredmetu"
              suffix="€"
              textRight
              hide-details
              hide-label
              :disabled="isCalculating || !jeDealer"
              @dataLoaded="visiblePoplatkyHeader('ukon_popl', 's_dph')"
              :decimalPlaces="2"
              replaceNull
            ></numeric-text-box>
          </v-col>
        </v-row>
        <v-row no-gutters class="poplatok-row px-12px mx-0px" v-show="zvSplKoniecVisible">
          <v-col xl="6" lg="6" md="6" class="pl-0px">
            <span class="f16">{{ zv_spl_koniec.nazov }}</span>
          </v-col>
          <v-col xl="2" lg="2" md="2" class="px-11px">
            <numeric-text-box
              dense
              dynamic
              :parentReloaded="produktFormReloaded"
              ref="zv_spl_koniec_perc"
              @valueChanged="zvSplKoniecPercValueChanged"
              :cisloPlz="cisloPlz"
              dataId="liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_perc"
              :key="'liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_perc' + cisloPlz"
              :cisloPredmetu="cisloPredmetu"
              suffix="%"
              textRight
              hide-details
              hide-label
              :disabled="isCalculating"
              @dataLoaded="visiblePoplatkyHeader('zv_spl_koniec', 'perc')"
              :decimalPlaces="3"
              replaceNull
            ></numeric-text-box>
          </v-col>
          <v-col xl="2" lg="2" md="2" class="px-11px">
            <numeric-text-box
              dense
              dynamic
              :parentReloaded="produktFormReloaded"
              ref="zv_spl_koniec_zakl"
              @valueChanged="zvSplKoniecZaklValueChanged"
              :cisloPlz="cisloPlz"
              dataId="liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_zakl"
              :key="'liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_zakl' + cisloPlz"
              :cisloPredmetu="cisloPredmetu"
              suffix="€"
              textRight
              hide-details
              hide-label
              :disabled="isCalculating || !jeDealer"
              @dataLoaded="visiblePoplatkyHeader('zv_spl_koniec', 'zakl')"
              :decimalPlaces="2"
              replaceNull
            ></numeric-text-box>
          </v-col>
          <v-col xl="2" lg="2" md="2" class="px-11px">
            <numeric-text-box
              dense
              dynamic
              :parentReloaded="produktFormReloaded"
              ref="zv_spl_koniec_s_dph"
              @valueChanged="zvSplKoniecSDphValueChanged"
              :cisloPlz="cisloPlz"
              dataId="liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_s_dph"
              :key="'liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_s_dph' + cisloPlz"
              :cisloPredmetu="cisloPredmetu"
              suffix="€"
              textRight
              hide-details
              hide-label
              :disabled="isCalculating || !jeDealer"
              @dataLoaded="visiblePoplatkyHeader('zv_spl_koniec', 's_dph')"
              :decimalPlaces="2"
              replaceNull
            ></numeric-text-box>
          </v-col>
        </v-row>
        <v-row no-gutters class="poplatok-row px-12px mx-0px" v-show="zostHodnVisible">
          <v-col xl="6" lg="6" md="6" class="pl-0px">
            <span class="f16">{{ zost_hodn.nazov }}</span>
          </v-col>
          <v-col xl="2" lg="2" md="2" class="px-11px">
            <numeric-text-box
              dense
              dynamic
              :parentReloaded="produktFormReloaded"
              ref="zost_hodnota_perc"
              @valueChanged="zostHodnotaPercValueChanged"
              :cisloPlz="cisloPlz"
              dataId="liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_perc"
              :key="'liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_perc' + cisloPlz"
              :cisloPredmetu="cisloPredmetu"
              suffix="%"
              textRight
              hide-details
              hide-label
              :disabled="isCalculating"
              @dataLoaded="visiblePoplatkyHeader('zost_hodnota', 'perc')"
              :decimalPlaces="3"
              replaceNull
            ></numeric-text-box>
          </v-col>
          <v-col xl="2" lg="2" md="2" class="px-11px">
            <numeric-text-box
              dense
              dynamic
              :parentReloaded="produktFormReloaded"
              ref="zost_hodnota_zakl"
              @valueChanged="zostHodnotaZaklValueChanged"
              :cisloPlz="cisloPlz"
              dataId="liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_zakl"
              :key="'liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_zakl' + cisloPlz"
              :cisloPredmetu="cisloPredmetu"
              suffix="€"
              textRight
              hide-details
              hide-label
              :disabled="isCalculating"
              @dataLoaded="visiblePoplatkyHeader('zost_hodnota', 'zakl')"
              :decimalPlaces="2"
              replaceNull
            ></numeric-text-box>
          </v-col>
          <v-col xl="2" lg="2" md="2" class="px-11px">
            <numeric-text-box
              dense
              dynamic
              :parentReloaded="produktFormReloaded"
              ref="zost_hodnota_s_dph"
              @valueChanged="zostHodnotaSDphValueChanged"
              :cisloPlz="cisloPlz"
              dataId="liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_s_dph"
              :key="'liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_s_dph' + cisloPlz"
              :cisloPredmetu="cisloPredmetu"
              suffix="€"
              textRight
              hide-details
              hide-label
              :disabled="isCalculating"
              @dataLoaded="visiblePoplatkyHeader('zost_hodnota', 's_dph')"
              :decimalPlaces="2"
              replaceNull
            ></numeric-text-box>
          </v-col>
        </v-row>
      </template>
      <!-- MOBIL -->
      <template v-else>
        <!-- POPLATOK ZA SPRACOVANIE -->
        <div v-if="spPoplVisible" class="mobile-poplatok-card mt-4">
          <v-row no-gutters class="pt-4">
            <v-col cols="12">
              <span class="f12 gs100">Názov poplatku</span>
            </v-col>
            <v-col cols="12">
              <span class="f16 bold">{{ sp_popl.nazov }}</span>
            </v-col>
          </v-row>
          <v-row no-gutters class="pt-4">
            <v-col :cols="(isControlDisabled('sprac_popl_perc','liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_perc') && $refs.sprac_popl_perc.l_visible) ? 6 : 12" class="pb-4">
              <template v-if="isControlDisabled('sprac_popl_perc','liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_perc') && $refs.sprac_popl_perc.l_visible">
                <v-row no-gutters>
                  <span class="f12 gs100">{{ $refs.sprac_popl_perc.getLabel }}</span>
                </v-row>
                <v-row no-gutters
                class="bold">
                  <span class="f16">{{ 
                    $refs.sprac_popl_perc.stringValue + " " + $refs.sprac_popl_perc.suffix
                    }}
                  </span>
                </v-row>
              </template>
                            
              <numeric-text-box 
                v-show="isReversedControlDisabled('sprac_popl_perc','liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_perc')"
                dynamic
                :parentReloaded="produktFormReloaded"
                ref="sprac_popl_perc"
                @valueChanged="spracPoplPercValueChanged"
                :cisloPlz="cisloPlz"
                dataId="liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_perc"
                :key="'liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_perc' + cisloPlz"
                :cisloPredmetu="cisloPredmetu"
                suffix="%"
                hide-details
                customLabel="Výška v %"
                :disabled="isCalculating"
                @dataLoaded="visiblePoplatkyHeader('sprac_popl', 'perc')"
                :decimalPlaces="3"
                replaceNull
              ></numeric-text-box>
            </v-col>
            <v-col :cols="(isControlDisabled('sprac_popl_zakl','liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_zakl') && $refs.sprac_popl_zakl.l_visible) ? 6 : 12" class="pb-4">
              <template v-if="isControlDisabled('sprac_popl_zakl','liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_zakl') && $refs.sprac_popl_zakl.l_visible">
                <v-row no-gutters>
                  <span class="f12 gs100">{{ $refs.sprac_popl_zakl.getLabel }}</span>
                </v-row>
                <v-row no-gutters
                class="bold">
                  <span class="f16">{{ 
                    $refs.sprac_popl_zakl.stringValue + " " + $refs.sprac_popl_zakl.suffix
                    }}
                  </span>
                </v-row>
              </template>

              <numeric-text-box
                v-show="isReversedControlDisabled('sprac_popl_zakl','liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_zakl')"
                dynamic
                :parentReloaded="produktFormReloaded"
                @valueChanged="spracPoplZaklValueChanged"
                ref="sprac_popl_zakl"
                :cisloPlz="cisloPlz"
                dataId="liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_zakl"
                :key="'liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_zakl' + cisloPlz"
                :cisloPredmetu="cisloPredmetu"
                suffix="€"
                hide-details
                customLabel="Základ"
                :disabled="isCalculating || !jeDealer"
                @dataLoaded="visiblePoplatkyHeader('sprac_popl', 'zakl')"
                :decimalPlaces="2"
                replaceNull
              ></numeric-text-box>
            </v-col>
            <v-col :cols="(isControlDisabled('sprac_popl_s_dph','liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_s_dph') && $refs.sprac_popl_s_dph.l_visible) ? 6 : 12" class="pb-4">
              <template v-if="isControlDisabled('sprac_popl_s_dph','liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_s_dph') && $refs.sprac_popl_s_dph.l_visible">
                <v-row no-gutters>
                  <span class="f12 gs100">{{ $refs.sprac_popl_s_dph.getLabel }}</span>
                </v-row>
                <v-row no-gutters
                class="bold">
                  <span class="f16">{{ 
                    $refs.sprac_popl_s_dph.stringValue  + " " + $refs.sprac_popl_s_dph.suffix
                    }}
                  </span>
                </v-row>
              </template>

              <numeric-text-box
                v-show="isReversedControlDisabled('sprac_popl_s_dph','liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_s_dph')"
                dynamic
                :parentReloaded="produktFormReloaded"
                @valueChanged="spracPoplSDphValueChanged"
                ref="sprac_popl_s_dph"
                :cisloPlz="cisloPlz"
                dataId="liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_s_dph"
                :key="'liw_filip__wiz_kalkulacia_produkt__txt_sprac_popl_s_dph' + cisloPlz"
                :cisloPredmetu="cisloPredmetu"
                suffix="€"
                hide-details
                :customLabel="jeDealer ? 'Spolu' : 'Cena s DPH'"
                :disabled="isCalculating || !jeDealer"
                @dataLoaded="visiblePoplatkyHeader('sprac_popl', 's_dph')"
                :decimalPlaces="2"
                replaceNull
              ></numeric-text-box>
            </v-col>
          </v-row>
        </div>
        <!-- POPLATOK ZA UKONČENIE -->
        <div v-if="ukonPoplVisible" class="mobile-poplatok-card mt-4">
          <v-row no-gutters class="pt-4">
            <v-col cols="12">
              <span class="f12 gs100">Názov poplatku</span>
            </v-col>
            <v-col cols="12">
              <span class="f16 bold">{{ ukon_popl.nazov }}</span>
            </v-col>
          </v-row>
          <v-row no-gutters class="pt-4">
            <v-col :cols="(isControlDisabled('ukon_popl_perc','liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_perc')  && $refs.ukon_popl_perc.l_visible) ? 6 : 12" class="pb-4">
              <template v-if="isControlDisabled('ukon_popl_perc','liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_perc') && $refs.ukon_popl_perc.l_visible">
                <v-row no-gutters>
                  <span class="f12 gs100">{{ $refs.ukon_popl_perc.getLabel }}</span>
                </v-row>
                <v-row no-gutters
                class="bold">
                  <span class="f16">{{ 
                    $refs.ukon_popl_perc.stringValue + " " + $refs.ukon_popl_perc.suffix
                    }}
                  </span>
                </v-row>
              </template>

              <numeric-text-box
                v-show="isReversedControlDisabled('ukon_popl_perc','liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_perc')"
                dynamic
                :parentReloaded="produktFormReloaded"
                @valueChanged="ukonPoplPercValueChanged"
                ref="ukon_popl_perc"
                :cisloPlz="cisloPlz"
                dataId="liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_perc"
                :key="'liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_perc' + cisloPlz"
                :cisloPredmetu="cisloPredmetu"
                suffix="%"
                hide-details
                customLabel="Výška v %"
                :disabled="isCalculating"
                @dataLoaded="visiblePoplatkyHeader('ukon_popl', 'perc')"
                :decimalPlaces="3"
                replaceNull
              ></numeric-text-box>
            </v-col>
            <v-col :cols="(isControlDisabled('ukon_popl_zakl','liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_zakl')  && $refs.ukon_popl_zakl.l_visible) ? 6 : 12" class="pb-4">
              <template v-if="isControlDisabled('ukon_popl_zakl','liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_zakl') && $refs.ukon_popl_zakl.l_visible">
                <v-row no-gutters>
                  <span class="f12 gs100">{{ $refs.ukon_popl_zakl.getLabel }}</span>
                </v-row>
                <v-row no-gutters
                class="bold">
                  <span class="f16">{{ 
                    $refs.ukon_popl_zakl.stringValue + " " + $refs.ukon_popl_zakl.suffix
                    }}
                  </span>
                </v-row>
              </template>

              <numeric-text-box
                v-show="isReversedControlDisabled('ukon_popl_zakl','liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_zakl')"
                dynamic
                :parentReloaded="produktFormReloaded"
                @valueChanged="ukonPoplZaklValueChanged"
                ref="ukon_popl_zakl"
                :cisloPlz="cisloPlz"
                dataId="liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_zakl"
                :key="'liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_zakl' + cisloPlz"
                :cisloPredmetu="cisloPredmetu"
                suffix="€"
                hide-details
                customLabel="Základ"
                :disabled="isCalculating || !jeDealer"
                @dataLoaded="visiblePoplatkyHeader('ukon_popl', 'zakl')"
                :decimalPlaces="2"
                replaceNull
              ></numeric-text-box>
            </v-col>
            <v-col :cols="(isControlDisabled('ukon_popl_s_dph','liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_s_dph') && $refs.ukon_popl_s_dph.l_visible) ? 6 : 12" class="pb-4">
              <template v-if="isControlDisabled('ukon_popl_s_dph','liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_s_dph') && $refs.ukon_popl_s_dph.l_visible">
                <v-row no-gutters>
                  <span class="f12 gs100">{{ $refs.ukon_popl_s_dph.getLabel }}</span>
                </v-row>
                <v-row no-gutters
                class="bold">
                  <span class="f16">{{ 
                    $refs.ukon_popl_s_dph.stringValue + " " + $refs.ukon_popl_s_dph.suffix
                    }}
                  </span>
                </v-row>
              </template>

              <numeric-text-box
                v-show="isReversedControlDisabled('ukon_popl_s_dph','liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_s_dph')"
                dynamic
                :parentReloaded="produktFormReloaded"
                ref="ukon_popl_s_dph"
                @valueChanged="ukonPoplSDphValueChanged"
                :cisloPlz="cisloPlz"
                dataId="liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_s_dph"
                :key="'liw_filip__wiz_kalkulacia_produkt__txt_ukon_popl_s_dph' + cisloPlz"
                :cisloPredmetu="cisloPredmetu"
                suffix="€"
                hide-details
                :customLabel="jeDealer ? 'Spolu' : 'Cena s DPH'"
                :disabled="isCalculating || !jeDealer"
                @dataLoaded="visiblePoplatkyHeader('ukon_popl', 's_dph')"
                :decimalPlaces="2"
                replaceNull
              ></numeric-text-box>
            </v-col>
          </v-row>
        </div>
        <!-- POSLEDNA ZVYSENA SPLATKA -->
        <div v-if="zvSplKoniecVisible" class="mobile-poplatok-card mt-4">
          <v-row no-gutters class="pt-4">
            <v-col cols="12">
              <span class="f12 gs100">Názov poplatku</span>
            </v-col>
            <v-col cols="12">
              <span class="f16 bold">{{ zv_spl_koniec.nazov }}</span>
            </v-col>
          </v-row>
          <v-row no-gutters class="pt-4">
            <v-col :cols="(isControlDisabled('zv_spl_koniec_perc','liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_perc') && $refs.zv_spl_koniec_perc.l_visible) ? 6 : 12" class="pb-4">
              <template v-if="isControlDisabled('zv_spl_koniec_perc','liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_perc') && $refs.zv_spl_koniec_perc.l_visible">
                <v-row no-gutters>
                  <span class="f12 gs100">{{ $refs.zv_spl_koniec_perc.getLabel }}</span>
                </v-row>
                <v-row no-gutters
                class="bold">
                  <span class="f16">{{ 
                    $refs.zv_spl_koniec_perc.stringValue + " " + $refs.zv_spl_koniec_perc.suffix
                    }}
                  </span>
                </v-row>
              </template>

              <numeric-text-box
                v-show="isReversedControlDisabled('zv_spl_koniec_perc','liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_perc')"
                dynamic
                :parentReloaded="produktFormReloaded"
                ref="zv_spl_koniec_perc"
                @valueChanged="zvSplKoniecPercValueChanged"
                :cisloPlz="cisloPlz"
                dataId="liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_perc"
                :key="'liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_perc' + cisloPlz"
                :cisloPredmetu="cisloPredmetu"
                suffix="%"
                hide-details
                customLabel="Výška v %"
                :disabled="isCalculating"
                @dataLoaded="visiblePoplatkyHeader('zv_spl_koniec', 'perc')"
                :decimalPlaces="3"
                replaceNull
              ></numeric-text-box>
            </v-col>
            <v-col :cols="(isControlDisabled('zv_spl_koniec_zakl','liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_zakl') && $refs.zv_spl_koniec_zakl.l_visible) ? 6 : 12" class="pb-4">
              <template v-if="isControlDisabled('zv_spl_koniec_zakl','liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_zakl') && $refs.zv_spl_koniec_zakl.l_visible">
                <v-row no-gutters>
                  <span class="f12 gs100">{{ $refs.zv_spl_koniec_zakl.getLabel }}</span>
                </v-row>
                <v-row no-gutters
                class="bold">
                  <span class="f16">{{ 
                    $refs.zv_spl_koniec_zakl.stringValue + " " + $refs.zv_spl_koniec_zakl.suffix
                    }}
                  </span>
                </v-row>
              </template>

              <numeric-text-box
                v-show="isReversedControlDisabled('zv_spl_koniec_zakl','liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_zakl')"
                dynamic
                :parentReloaded="produktFormReloaded"
                ref="zv_spl_koniec_zakl"
                @valueChanged="zvSplKoniecZaklValueChanged"
                :cisloPlz="cisloPlz"
                dataId="liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_zakl"
                :key="'liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_zakl' + cisloPlz"
                :cisloPredmetu="cisloPredmetu"
                suffix="€"
                hide-details
                customLabel="Základ"
                :disabled="isCalculating || !jeDealer"
                @dataLoaded="visiblePoplatkyHeader('zv_spl_koniec', 'zakl')"
                :decimalPlaces="2"
                replaceNull
              ></numeric-text-box>
            </v-col>
            <v-col :cols="(isControlDisabled('zv_spl_koniec_s_dph','liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_s_dph') && $refs.zv_spl_koniec_s_dph.l_visible) ? 6 :12" class="pb-4">
              <template v-if="isControlDisabled('zv_spl_koniec_s_dph','liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_s_dph') && $refs.zv_spl_koniec_s_dph.l_visible">
                <v-row no-gutters>
                  <span class="f12 gs100">{{ $refs.zv_spl_koniec_s_dph.getLabel }}</span>
                </v-row>
                <v-row no-gutters
                class="bold">
                  <span class="f16">{{ 
                    $refs.zv_spl_koniec_s_dph.stringValue + " " + $refs.zv_spl_koniec_s_dph.suffix
                    }}
                  </span>
                </v-row>
              </template>

              <numeric-text-box
                v-show="isReversedControlDisabled('zv_spl_koniec_s_dph','liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_s_dph')"
                dynamic
                :parentReloaded="produktFormReloaded"
                ref="zv_spl_koniec_s_dph"
                @valueChanged="zvSplKoniecSDphValueChanged"
                :cisloPlz="cisloPlz"
                dataId="liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_s_dph"
                :key="'liw_filip__wiz_kalkulacia_produkt__txt_zv_spl_koniec_s_dph' + cisloPlz"
                :cisloPredmetu="cisloPredmetu"
                suffix="€"
                :customLabel="jeDealer ? 'Spolu' : 'Cena s DPH'"
                hide-details
                :disabled="isCalculating || !jeDealer"
                @dataLoaded="visiblePoplatkyHeader('zv_spl_koniec', 's_dph')"
                :decimalPlaces="2"
                replaceNull
              ></numeric-text-box>
            </v-col>
          </v-row>
        </div>
         <!-- ZOSTATOK -->
         <div v-if="zostHodnVisible" class="mobile-poplatok-card mt-4">
          <v-row no-gutters class="pt-4">
            <v-col cols="12">
              <span class="f12 gs100">Názov poplatku</span>
            </v-col>
            <v-col cols="12">
              <span class="f16 bold">{{ zost_hodn.nazov }}</span>
            </v-col>
          </v-row>
          <v-row no-gutters class="pt-4">
            <v-col :cols="(isControlDisabled('zost_hodnota_perc','liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_perc') && $refs.zost_hodnota_perc.l_visible) ? 6 : 12" class="pb-4">
              <template v-if="isControlDisabled('zost_hodnota_perc','liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_perc') && $refs.zost_hodnota_perc.l_visible">
                <v-row no-gutters>
                  <span class="f12 gs100">{{ $refs.zost_hodnota_perc.getLabel }}</span>
                </v-row>
                <v-row no-gutters
                class="bold">
                  <span class="f16">{{ 
                    $refs.zost_hodnota_perc.stringValue + " " + $refs.zost_hodnota_perc.suffix
                    }}
                  </span>
                </v-row>
              </template>

              <numeric-text-box
                v-show="isReversedControlDisabled('zost_hodnota_perc','liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_perc')"
                dynamic
                :parentReloaded="produktFormReloaded"
                ref="zost_hodnota_perc"
                @valueChanged="zostHodnotaPercValueChanged"
                :cisloPlz="cisloPlz"
                dataId="liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_perc"
                :key="'liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_perc' + cisloPlz"
                :cisloPredmetu="cisloPredmetu"
                suffix="%"
                hide-details
                customLabel="Výška v %"
                :disabled="isCalculating"
                @dataLoaded="visiblePoplatkyHeader('zost_hodnota', 'perc')"
                :decimalPlaces="3"
                replaceNull
              ></numeric-text-box>
            </v-col>
            <v-col :cols="(isControlDisabled('zost_hodnota_zakl','liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_zakl') && $refs.zost_hodnota_zakl.l_visible) ? 6 : 12" class="pb-4">
              <template v-if="isControlDisabled('zost_hodnota_zakl','liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_zakl') && $refs.zost_hodnota_zakl.l_visible">
                <v-row no-gutters>
                  <span class="f12 gs100">{{ $refs.zost_hodnota_zakl.getLabel }}</span>
                </v-row>
                <v-row no-gutters
                class="bold">
                  <span class="f16">{{ 
                    $refs.zost_hodnota_zakl.stringValue + " " + $refs.zost_hodnota_zakl.suffix
                    }}
                  </span>
                </v-row>
              </template>

              <numeric-text-box
                v-show="isReversedControlDisabled('zost_hodnota_zakl','liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_zakl')"
                dynamic
                :parentReloaded="produktFormReloaded"
                ref="zost_hodnota_zakl"
                @valueChanged="zostHodnotaZaklValueChanged"
                :cisloPlz="cisloPlz"
                dataId="liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_zakl"
                :key="'liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_zakl' + cisloPlz"
                :cisloPredmetu="cisloPredmetu"
                suffix="€"
                hide-details
                customLabel="Základ"
                :disabled="isCalculating"
                @dataLoaded="visiblePoplatkyHeader('zost_hodnota', 'zakl')"
                :decimalPlaces="2"
                replaceNull
              ></numeric-text-box>
            </v-col>
            <v-col :cols="(isControlDisabled('zost_hodnota_s_dph','liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_s_dph') && $refs.zost_hodnota_s_dph.l_visible) ? 6 : 12" class="pb-4">
              <template v-if="isControlDisabled('zost_hodnota_s_dph','liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_s_dph') && $refs.zost_hodnota_s_dph.l_visible">
                <v-row no-gutters>
                  <span class="f12 gs100">{{ $refs.zost_hodnota_s_dph.getLabel }}</span>
                </v-row>
                <v-row no-gutters
                class="bold">
                  <span class="f16">{{ 
                    $refs.zost_hodnota_s_dph.stringValue + " " + $refs.zost_hodnota_s_dph.suffix
                    }}
                  </span>
                </v-row>
              </template>

              <numeric-text-box
                v-show="isReversedControlDisabled('zost_hodnota_s_dph','liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_s_dph')"
                dynamic
                :parentReloaded="produktFormReloaded"
                ref="zost_hodnota_s_dph"
                @valueChanged="zostHodnotaSDphValueChanged"
                :cisloPlz="cisloPlz"
                dataId="liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_s_dph"
                :key="'liw_filip__wiz_kalkulacia_produkt__txt_zost_hodnota_s_dph' + cisloPlz"
                :cisloPredmetu="cisloPredmetu"
                suffix="€"
                hide-details
                :customLabel="jeDealer ? 'Spolu' : 'Cena s DPH'"
                :disabled="isCalculating"
                @dataLoaded="visiblePoplatkyHeader('zost_hodnota', 's_dph')"
                :decimalPlaces="2"
                replaceNull
              ></numeric-text-box>
            </v-col>
          </v-row>
        </div>
      </template>
    </template>
    
    <!-- #################### -->
    <!-- PARAMETRE KALKULACIE -->
    <!-- #################### -->
    <div v-if="jeDealer  && visibleParameterKalkulacieHeader" class="f18 mt-30px" :class="{ 'mb-4': isMobile }">Parametre kalkulácie</div>
    <div :class="{ 'px-5px': !isMobile }">
      <v-row v-show="visibleParameterKalkulacieHeader" :class="{ 'flex-column': isMobile }" :no-gutters="isMobile">
        <v-col md="4" sm="12" v-show="parametreVisible.zisk_zakl">
          <numeric-text-box
            ref="zisk_zakl"
            :parentReloaded="produktFormReloaded"
            :cisloPlz="cisloPlz"
            dataId="liw_filip__wiz_kalkulacia_produkt__txt_zisk"
            :key="'liw_filip__wiz_kalkulacia_produkt__txt_zisk' + cisloPlz"
            suffix="%"
            :cisloPredmetu="cisloPredmetu"
            @valueChanged="
              val => {
                ziskLoaded(val);
                posliProduktFormDirty(true);
              }
            "
            @dataLoaded="(val)=> {ziskLoaded(val); visibleParameterKalkulacie('zisk_zakl')}"
            :disabled="isCalculating"
            :decimalPlaces="4"
          />
        </v-col>
        <v-col md="4" sm="12">
          <numeric-text-box
            ref="korekcia_refi"
            :parentReloaded="produktFormReloaded"
            :cisloPlz="cisloPlz"
            dataId="liw_filip__wiz_kalkulacia_produkt__txt_korekcia_refi"
            :key="'liw_filip__wiz_kalkulacia_produkt__txt_korekcia_refi' + cisloPlz"
            :cisloPredmetu="cisloPredmetu"
            suffix="%"
            @valueChanged="posliProduktFormDirty(true)"
            :disabled="isCalculating"
            @dataLoaded="()=> visibleParameterKalkulacie('korekcia_refi')"
          />
        </v-col>
        <v-col md="4" sm="12">
          <check-box
              ref="ignorovat_prirazky"
              :parentReloaded="produktFormReloaded"
              :cisloPlz="cisloPlz"
              dataId="liw_filip__wiz_kalkulacia_produkt__btn_ignorovat_prirazky"
              :key="'liw_filip__wiz_kalkulacia_produkt__btn_ignorovat_prirazky' + cisloPlz"
              :cisloPredmetu="pripad.cisloPredmetu"
              :style="isMobile ? { marginTop: '0px' } : { marginTop: '20px' }"
              @valueChanged="val => {
                changeIgnorovatPrirazky(val);
              }"
              @dataLoaded="(val) => {ignotovat_prirazky = val == 1 ? true : false;visibleParameterKalkulacie('ignorovat_prirazky')}"
              hideDetails
              :disabled="isCalculating"
            />
        </v-col>
      </v-row>
      <div class="f18 mt-4" :class="{ 'mb-4' : isMobile }">
        <template> Možnosti financovania </template>
      </div>
      <v-divider v-if="!isMobile" class="mt-2"></v-divider>
      <!-- DESKTOP -->
      <template v-if="!isMobile">
        <v-data-table
          :headers="headers"
          v-model="selected"
          @item-selected="onVariantSelected"
          :items="kalkulaciaItems"
          hide-default-footer
          show-select
          :single-select="false"
          disable-pagination
          item-key="pkid"
        >
          <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
            <v-tooltip left open-delay="800">
              <template v-slot:activator="{ on, attrs }">
                <v-simple-checkbox
                  class="dynamic_check_box"
                  v-bind="attrs"
                  v-on="on"
                  :value="isSelected"
                  :disabled="!!pripad.predmetZamknuty || isCalculating"
                  @input="select($event)"
                  :ripple="false"
                ></v-simple-checkbox>
              </template>
              Označením checkboxu vyberiete varianty pre pre tlač ponuky
            </v-tooltip>
          </template>
          <template v-slot:[`header.data-table-select`]>
            <v-tooltip left open-delay="800">
              <template v-slot:activator="{ on, attrs }">
                <v-simple-checkbox
                  class="dynamic_check_box"
                  v-bind="attrs"
                  v-on="on"
                  v-model="checkAll"
                  v-show="checkAllVisible"
                  @input="allVariantsSelected($event)"
                  :ripple="false"
                  :disabled="isCalculating"
                ></v-simple-checkbox>
              </template>
              Označením checkboxu vyberiete všetky varianty pre tlač ponuky
            </v-tooltip>
          </template>
          <template v-slot:[`header.pozad_cisty_prijem`]="{ header }">
            <span style="white-space: nowrap">
              {{ header.text }} 
              <v-tooltip bottom open-delay="200">
                <template v-slot:activator="{ on }">
                  <v-icon slot="activator" class="btn-help text-body-2 ml-2" style="position: relative" v-on="on"
                    >mdi-help-circle</v-icon
                  >
                </template>
                Požadovaný príjem po odpočítaní životného minima a splátky v danom riadku.
              </v-tooltip> 
            </span>  
          </template>
          <template v-slot:[`header.rpmn`]="{ header }">
            <span style="white-space: nowrap">
              {{ header.text }} 
              <v-tooltip bottom open-delay="200">
                <template v-slot:activator="{ on }">
                  <v-icon slot="activator" class="btn-help text-body-2 ml-2" style="position: relative" v-on="on"
                    >mdi-help-circle</v-icon
                  >
                </template>
                Ročná percentuálna miera nákladov
              </v-tooltip> 
            </span>  
          </template>
          <template v-slot:[`item.akontacia`]="{ item }">
            {{ item.akontacia >= 0 ? item.akontacia.toPercentString(2) : null }}
          </template>
          <template v-slot:[`item.dlzka_leasingu`]="{ item }">
            {{ item.dlzka_leasingu >= 0 ? item.dlzka_leasingu : null }}
          </template>
          <template v-slot:[`item.prva_platba_s_dph`]="{ item }">
            {{ item.prva_platba_s_dph >= 0 ? item.prva_platba_s_dph.toEurString() : null }}
          </template>
          <template v-slot:[`item.prva_platba_bez_dph`]="{ item }">
            {{ item.prva_platba_bez_dph >= 0 ? item.prva_platba_bez_dph.toEurString() : null }}
          </template>
          <template v-slot:[`item.splatka_s_poistenim_s_dph`]="{ item }">
            {{
              item.splatka_s_poistenim_s_dph >= 0
                ? item.splatka_s_poistenim_s_dph.toEurString()
                : null
            }}
          </template>
          <template v-slot:[`item.splatka_s_poistenim_bez_dph`]="{ item }">
            {{
              item.splatka_s_poistenim_bez_dph >= 0
                ? item.splatka_s_poistenim_bez_dph.toEurString()
                : null
            }}
          </template>
          <template v-slot:[`item.splatka_s_dph`]="{ item }">
            {{ item.splatka_s_dph >= 0 ? item.splatka_s_dph.toEurString() : null }}
          </template>
          <template v-slot:[`item.splatka_bez_dph`]="{ item }">
            {{ item.splatka_bez_dph >= 0 ? item.splatka_bez_dph.toEurString() : null }}
          </template>
          <template v-slot:[`item.klientsky_urok`]="{ item }">
            {{ item.klientsky_urok >= 0 ? item.klientsky_urok.toPercentString(2) : '0,00%' }}
          </template>
          <template v-slot:[`item.rpmn`]="{ item }">
            {{ item.rpmn >= 0 ? item.rpmn.toPercentString(2) : '0,00%' }}
          </template>
          <template v-slot:[`item.sp_popl_s_dph`]="{ item }">
            {{ item.sp_popl_s_dph >= 0 ? item.sp_popl_s_dph.toEurString() : null }}
          </template>
          <template v-slot:[`item.sp_popl_bez_dph`]="{ item }">
            {{ item.sp_popl_bez_dph >= 0 ? item.sp_popl_bez_dph.toEurString() : null }}
          </template>
          <template v-slot:[`item.zost_hodnota_s_dph`]="{ item }">
            {{ item.zost_hodnota_s_dph > 0 ? item.zost_hodnota_s_dph.toEurString() : null }}
          </template>
          <template v-slot:[`item.zv_spl_koniec_s_dph`]="{ item }">
            {{ item.zv_spl_koniec_s_dph > 0 ? item.zv_spl_koniec_s_dph.toEurString() : null }}
          </template>
          <template v-slot:[`item.zost_hodnota_bez_dph`]="{ item }">
            {{ item.zost_hodnota_bez_dph > 0 ? item.zost_hodnota_bez_dph.toEurString() : null }}
          </template>
          <template v-slot:[`item.zv_spl_koniec_bez_dph`]="{ item }">
            {{ item.zv_spl_koniec_bez_dph > 0 ? item.zv_spl_koniec_bez_dph.toEurString() : null }}
          </template>
          <template v-slot:[`item.vynos`]="{ item }">
            {{ item.vynos != null ? item.vynos.toEurString() : null }}
          </template>
          <template v-slot:[`item.vynosovost_perc`]="{ item }">
            {{ item.vynosovost_perc != null ? item.vynosovost_perc.toPercentString(2) : null  }}
          </template>
          <template v-slot:[`item.id_color`]="{ item }">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  class="mr-4"
                  v-bind:class="{
                    'semafor semafor-success': item.id_color === 1,
                    'semafor semafor-warn': item.id_color === 2,
                    'semafor semafor-negative': item.id_color === 3,
                  }"
                ></div>
              </template>
              <span v-if="item.id_color == 1">Predschválené</span>
              <span v-if="item.id_color == 2">Na individuálne schválenie</span>
              <span v-if="item.id_color == 3">Zamietnuté</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.pozad_cisty_prijem`]="{ item }">
            {{ item.pozad_cisty_prijem > 0 ? item.pozad_cisty_prijem.toEurString() : null }}
          </template>
          <template v-slot:[`item.pom_zisk`]="{ item }">
            <variant-zisk-text-box
            :ref="'variantZisk' + item.pkid"
            :value="item.pom_zisk"
            :zakladZisk="zisk"
            @input="val => onChangeZiskZakl(val, item)"
            :disabled="item.zisk_is_enabled == 0 || ignotovat_prirazky || isCalculating"
            @error="variantZiskError"
            :decimalPlaces="4"
            :tolerancia="100"
            ></variant-zisk-text-box>
          </template>
          <template v-slot:[`item.zlava_zo_splatky`]="{ item }">
            <numeric-text-box
              :value="item.zlava_zo_splatky"
              suffix="€"
              :decimalPlaces="2"
              :textRight="true"
              :hideLabel="true"
              hide-details
              hide-tooltip
              :disabled="isCalculating"
              @input="val => onChangeZlavaZakl(val, item)"
              dense
            />
          </template>
        </v-data-table>
      </template>
      <!-- MOBIL -->
      <template v-else>
        <v-row no-gutters class="mobile-moznosti-financovania-card d-flex flex-wrap" v-for="(item, index) in kalkulaciaItems" :key="index"
          :class="{ 'mobile-card-picked' : item.selected }" @click="checkMobileItem(item)">
          <v-col v-if="headers.filter(h => h.value == 'id_color').length > 0" cols="12" class="pb-2">
              <div v-bind:class="{
                  'mobile-semafor semafor-success': item.id_color === 1,
                  'mobile-semafor semafor-warn': item.id_color === 2,
                  'mobile-semafor semafor-negative': item.id_color === 3,
                }">                  
                <div v-bind:class="{
                  'semafor-dot success': item.id_color === 1,
                  'semafor-dot warn': item.id_color === 2,
                  'semafor-dot negative': item.id_color === 3,
                }"></div>
                <div class="f12 pt-3px pl-22px pr-8px">
                  <span v-if="item.id_color == 1">Predschválené</span>
                  <span v-if="item.id_color == 2">Na individuálne schválenie</span>
                  <span v-if="item.id_color == 3">Zamietnuté</span>
                </div>
              </div>
          </v-col>
          <v-col v-for="header in headers.filter(h => h.value !== 'pom_zisk' && h.value !== 'id_color' && h.value !== 'zlava_zo_splatky')" 
              :key="header.value" :cols="header.value == 'dlzka_leasingu' || header.value == 'rocny_najazd' ? 12 : 6" :class="header.align" class="pb-4">
              <v-row no-gutters>
                <span class="f12 gs100">{{ header.text }}</span>
              </v-row>
              <v-row no-gutters>
                <span class="f16 bold">{{ transformKalkulaciaItemValue(header.value, item[header.value]) }}</span>
              </v-row>
          </v-col>
          <v-col v-if="headers.filter(h => h.value == 'zlava_zo_splatky').length > 0" cols="12" class="pb-4">
            <numeric-text-box
              :value="item.zlava_zo_splatky"
              suffix="€"
              :decimalPlaces="2"
              :textRight="true"
              :hideLabel="true"
              hide-details
              hide-tooltip
              :disabled="isCalculating"
              @input="val => onChangeZlavaZakl(val, item)"
            />
          </v-col>
          <v-col v-if="headers.filter(h => h.value == 'pom_zisk').length > 0" cols="12" class="pb-4">
            <variant-zisk-text-box
            :ref="'variantZisk' + item.pkid"
            :value="item.pom_zisk"
            :zakladZisk="zisk"
            @input="val => onChangeZiskZakl(val, item)"
            :disabled="item.zisk_is_enabled == 0 || ignotovat_prirazky || isCalculating"
            @error="variantZiskError"
            :decimalPlaces="4"
            :tolerancia="100"
            :dense="false"
            :textRight="false"
            :hideLabel="false"
            ></variant-zisk-text-box>
          </v-col>
        </v-row>
      </template>
    </div>
  </v-card>
</template>
<script>
import CheckBox from '../basic/CheckBox.vue';
import DynamicCombo from '../basic/DynamicCombo.vue';
import ButtonGroup from '../basic/ButtonGroup.vue';
import TextBox from '../basic/TextBox.vue';
import NumericTextBox from '../basic/NumericTextBox.vue';
import DatePicker from '../basic/DatePicker.vue';
import protectedAxios from '../../auth/axios';
import { mapState, mapGetters, mapMutations } from 'vuex';
import { eventBus } from '../../main.js';
import { controlMixin } from '../../mixins/controlMixin.js';
import VariantZiskTextBox from './VariantZiskTextBox.vue';

let produktFormLoadingDialogCounter = 0;

export default {
  components: {
    TextBox,
    DynamicCombo,
    CheckBox,
    ButtonGroup,
    DatePicker,
    NumericTextBox,
    VariantZiskTextBox
  },
  mixins:[controlMixin],
  computed: {
    ...mapState(['pripad']),
    ...mapGetters(['jeDealer','jePrihlaseny','pravoDodatocneKalkVstupy','isMobile']),
    visiblePoplatky() {
      return (
        this.spPoplVisible ||
        this.ukonPoplVisible ||
        this.zvSplKoniecVisible ||
        this.zostHodnVisible
      );
    },
    poplatkyVisiblePerc() {
      return (
        this.poplatkyVisible.sprac_popl.perc ||
        this.poplatkyVisible.ukon_popl.perc ||
        this.poplatkyVisible.zv_spl_koniec.perc ||
        this.poplatkyVisible.zost_hodnota.perc
      );
    },
    poplatkyVisibleZakl() {
      return (
        this.poplatkyVisible.sprac_popl.zakl ||
        this.poplatkyVisible.ukon_popl.zakl ||
        this.poplatkyVisible.zv_spl_koniec.zakl ||
        this.poplatkyVisible.zost_hodnota.zakl
      );
    },
    poplatkyVisibleSDph() {
      return (
        this.poplatkyVisible.sprac_popl.s_dph ||
        this.poplatkyVisible.ukon_popl.s_dph ||
        this.poplatkyVisible.zv_spl_koniec.s_dph ||
        this.poplatkyVisible.zost_hodnota.s_dph
      );
    },
    spPoplVisible() {
      if (
        this.poplatkyVisible.sprac_popl.perc_loaded &&
        this.poplatkyVisible.sprac_popl.zakl_loaded &&
        this.poplatkyVisible.sprac_popl.s_dph_loaded
      ) {
        return (
          this.sp_popl.is_visible &&
          (this.poplatkyVisible.sprac_popl.perc ||
            this.poplatkyVisible.sprac_popl.zakl ||
            this.poplatkyVisible.sprac_popl.s_dph)
        );
      } else {
        return this.sp_popl.is_visible;
      }
    },
    ukonPoplVisible() {
      if (
        this.poplatkyVisible.ukon_popl.perc_loaded &&
        this.poplatkyVisible.ukon_popl.zakl_loaded &&
        this.poplatkyVisible.ukon_popl.s_dph_loaded
      ) {
        return (
          this.ukon_popl.is_visible &&
          (this.poplatkyVisible.ukon_popl.perc ||
            this.poplatkyVisible.ukon_popl.zakl ||
            this.poplatkyVisible.ukon_popl.s_dph)
        );
      } else {
        return this.ukon_popl.is_visible;
      }
    },
    zvSplKoniecVisible() {
      if (
        this.poplatkyVisible.zv_spl_koniec.perc_loaded &&
        this.poplatkyVisible.zv_spl_koniec.zakl_loaded &&
        this.poplatkyVisible.zv_spl_koniec.s_dph_loaded
      ) {
        return (
          this.zv_spl_koniec.is_visible &&
          (this.poplatkyVisible.zv_spl_koniec.perc ||
            this.poplatkyVisible.zv_spl_koniec.zakl ||
            this.poplatkyVisible.zv_spl_koniec.s_dph)
        );
      } else {
        return this.zv_spl_koniec.is_visible;
      }
    },
    zostHodnVisible() {
      if (
        this.poplatkyVisible.zost_hodnota.perc_loaded &&
        this.poplatkyVisible.zost_hodnota.zakl_loaded &&
        this.poplatkyVisible.zost_hodnota.s_dph_loaded
      ) {
        return (
          this.zost_hodn.is_visible &&
          (this.poplatkyVisible.zost_hodnota.perc ||
            this.poplatkyVisible.zost_hodnota.zakl ||
            this.poplatkyVisible.zost_hodnota.s_dph)
        );
      } else {
        return this.zost_hodn.is_visible;
      }
    },
    variantyError(){
      const ziskErrors = this.kalkulaciaItems
        .map(c => this.$refs['variantZisk' + c.pkid]?.error)
        .filter(c => c != '' && c != null);

      return this.odplataError ? [this.odplataError, ...ziskErrors] : ziskErrors
    },
    produktValidationError(){
        return this.variantyError?.length > 0 ? this.variantyError[0] : '';
    },
    visibleParameterKalkulacieHeader(){
      return this.parametreVisible.zisk_zakl || this.parametreVisible.ignorovat_prirazky || this.parametreVisible.korekcia_refi
    }
  },
  data() {
    return {
      headersGlobal: [
        { text: 'Dĺžka splácania', value: 'dlzka_leasingu'},
        { text: 'Akontácia %', value: 'akontacia'},
        {
          text: 'Akontácia s DPH',
          value: 'prva_platba_s_dph',
          align: this.dph ? '' : ' d-none',
        },
        {
          text: 'Prvá platba bez DPH',
          value: 'prva_platba_bez_dph',
          align: !this.dph ? '' : ' d-none',
        },
        {
          text: 'Splátka s poistením s DPH',
          value: 'splatka_s_poistenim_s_dph',
          align: this.dph ? '' : ' d-none',
        },
        {
          text: 'Splátka s poistením bez DPH',
          value: 'splatka_s_poistenim_bez_dph',
          align: !this.dph ? '' : ' d-none',
        },
        {
          text: 'Splátka bez poistenia s DPH',
          value: 'splatka_s_dph',
          align: this.dph ? '' : ' d-none',
        },
        {
          text: 'Splátka bez poistenia bez DPH',
          value: 'splatka_bez_dph',
          align: !this.dph ? '' : ' d-none',
        },
        {
          text: 'Poplatok s DPH',
          value: 'sp_popl_s_dph',
          align: this.dph ? '' : ' d-none',
        },
        {
          text: 'Poplatok bez DPH',
          value: 'sp_popl_bez_dph',
          align: !this.dph ? '' : ' d-none',
        },
        {
          text: 'Zostatková hodnota s DPH',
          value: 'zost_hodnota_s_dph',
          align: ' d-none',
        },
        {
          text: 'Zostatková hodnota bez DPH',
          value: 'zost_hodnota_bez_dph',
          align: ' d-none',
        },
        {
          text: 'Posledná zvýšená splátka s DPH',
          value: 'zv_spl_koniec_s_dph',
          align: ' d-none',
        },
        {
          text: 'Posledná zvýšená splátka bez DPH',
          value: 'zv_spl_koniec_bez_dph',
          align: ' d-none',
        },
        {
          text: 'Príjem',
          value: 'pozad_cisty_prijem',
        },
        { text: 'Klientský úrok', value: 'klientsky_urok' },
        { text: 'RPMN', value: 'rpmn' },
        { text: '', value: 'id_color', width: 10 ,align: ' pa-0 pr-4'},
        {
          text: 'Zisk',
          value: 'pom_zisk',
          width: 130,
          align: ' pl-0'
        },
      ],
      headersOLFS: [
        { text: 'Dĺžka splácania', value: 'dlzka_leasingu'},
        { text: 'Ročný nájazd', value: 'rocny_najazd'},
        {
          text: 'Splátka s poistením s DPH',
          value: 'splatka_s_dph',
          align: this.dph ? '' : ' d-none',
        },
        {
          text: 'Splátka s poistením bez DPH',
          value: 'splatka_bez_dph',
          align: !this.dph ? '' : ' d-none',
        },
        {
          text: 'Výnos',
          value: 'vynos',
        },
        {
          text: 'Zľava zo splátky',
          value: 'zlava_zo_splatky',
          width: 130,
          align: ' pl-0'
        },
        {
          text: '% výnosovosti',
          value: 'vynosovost_perc',
        },
        {
          text: 'Príjem',
          value: 'pozad_cisty_prijem',
        },
        { text: 'Klientský úrok', value: 'klientsky_urok' },
        { text: '', value: 'id_color', width: 10 ,align: ' pa-0 pr-4'},
      ],
      headers:[],
      kalkulaciaItems: [],
      formDirty: false,
      selected: [],
      sp_popl: {},
      ukon_popl: {},
      zv_spl_koniec: {},
      zost_hodn: {},
      produktFormReloaded: false,
      checkAll: false,
      checkAllVisible: false,
      poplatkyVisible: {
        sprac_popl: {
          perc: false,
          perc_loaded: false,
          zakl: false,
          zakl_loaded: false,
          s_dph: false,
          s_dph_loaded: false,
        },
        ukon_popl: {
          perc: false,
          perc_loaded: false,
          zakl: false,
          zakl_loaded: false,
          s_dph: false,
          s_dph_loaded: false,
        },
        zv_spl_koniec: {
          perc: false,
          perc_loaded: false,
          zakl: false,
          zakl_loaded: false,
          s_dph: false,
          s_dph_loaded: false,
        },
        zost_hodnota: {
          perc: false,
          perc_loaded: false,
          zakl: false,
          zakl_loaded: false,
          s_dph: false,
          s_dph_loaded: false,
        },
      },
      parametreVisible:{
        zisk_zakl: false,
        korekcia_refi: false,
        ignorovat_prirazky: false,
      },
      zisk: 0.0,
      ignotovat_prirazky: false,
      odplataError: '',
      zlavaChangePending: false
    };
  },
  props: {
    value: String,
    dph: Boolean,
    reloaded: Boolean,
    cisloPlz: String,
    idProduktu: Number,
    nazovProduktu: String,
    forceFormDirty: Boolean,
    cisloPredmetu: Number,
    isCalculating: Boolean,
    jeOlfs:{
      type: Number,
      default: 0
    }
  },
  watch: {
    formDirty(val) {
      this.posliProduktFormDirty(val);
    },
    forceFormDirty(val) {
      if (val) this.formDirty = true;
    },
    selected(val) {
      if (this.kalkulaciaItems.length > 0 && val.length == this.kalkulaciaItems.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    variantyError(val){
      if(this.zlavaChangePending) return;
      this.$emit('produktValid',val?.length > 0 ? val[0]: '')
    },
  },
  methods: {
    ...mapMutations(['openDialog','closeDialog']),
    toggleDefaultLoadingDialog(open, text = 'Prebieha načítanie dát, prosím počkajte ...') {
      if (open) {
        produktFormLoadingDialogCounter += 1;
      } else {
        produktFormLoadingDialogCounter = Math.max(0, produktFormLoadingDialogCounter - 1);
      }
      this.$emit('loadingOverlayChanged', {
        open,
        text,
      });
    },
    spracPoplPercValueChanged() {
      if (this.$refs.sprac_popl_perc.getDirty()) {
        this.$refs.sprac_popl_perc.setDirty(false);
        this.$refs.sprac_popl_zakl.loadData();
        this.$refs.sprac_popl_s_dph.loadData();
        this.formDirty = true;
      }
    },
    spracPoplZaklValueChanged() {
      if (this.$refs.sprac_popl_zakl.getDirty()) {
        this.$refs.sprac_popl_zakl.setDirty(false);
        this.$refs.sprac_popl_perc.loadData();
        this.$refs.sprac_popl_s_dph.loadData();
        this.formDirty = true;
      }
    },
    spracPoplSDphValueChanged() {
      if (this.$refs.sprac_popl_s_dph.getDirty()) {
        this.$refs.sprac_popl_s_dph.setDirty(false);
        this.$refs.sprac_popl_perc.loadData();
        this.$refs.sprac_popl_zakl.loadData();
        this.formDirty = true;
      }
    },
    ukonPoplPercValueChanged() {
      if (this.$refs.ukon_popl_perc.getDirty()) {
        this.$refs.ukon_popl_perc.setDirty(false);
        this.$refs.ukon_popl_zakl.loadData();
        this.$refs.ukon_popl_s_dph.loadData();
        this.formDirty = true;
      }
    },
    ukonPoplZaklValueChanged() {
      if (this.$refs.ukon_popl_zakl.getDirty()) {
        this.$refs.ukon_popl_zakl.setDirty(false);
        this.$refs.ukon_popl_perc.loadData();
        this.$refs.ukon_popl_s_dph.loadData();
        this.formDirty = true;
      }
    },
    ukonPoplSDphValueChanged() {
      if (this.$refs.ukon_popl_s_dph.getDirty()) {
        this.$refs.ukon_popl_s_dph.setDirty(false);
        this.$refs.ukon_popl_perc.loadData();
        this.$refs.ukon_popl_zakl.loadData();
        this.formDirty = true;
      }
    },
    zvSplKoniecPercValueChanged() {
      if (this.$refs.zv_spl_koniec_perc.getDirty()) {
        this.$refs.zv_spl_koniec_perc.setDirty(false);
        this.$refs.zv_spl_koniec_zakl.loadData();
        this.$refs.zv_spl_koniec_s_dph.loadData();
        this.formDirty = true;
      }
    },
    zvSplKoniecZaklValueChanged() {
      if (this.$refs.zv_spl_koniec_zakl.getDirty()) {
        this.$refs.zv_spl_koniec_zakl.setDirty(false);
        this.$refs.zv_spl_koniec_perc.loadData();
        this.$refs.zv_spl_koniec_s_dph.loadData();
        this.formDirty = true;
      }
    },
    zvSplKoniecSDphValueChanged() {
      if (this.$refs.zv_spl_koniec_s_dph.getDirty()) {
        this.$refs.zv_spl_koniec_s_dph.setDirty(false);
        this.$refs.zv_spl_koniec_perc.loadData();
        this.$refs.zv_spl_koniec_zakl.loadData();
        this.formDirty = true;
      }
    },
    zostHodnotaPercValueChanged() {
      if (this.$refs.zost_hodnota_perc.getDirty()) {
        this.$refs.zost_hodnota_perc.setDirty(false);
        this.$refs.zost_hodnota_zakl.loadData();
        this.$refs.zost_hodnota_s_dph.loadData();
        this.formDirty = true;
      }
    },
    zostHodnotaZaklValueChanged() {
      if (this.$refs.zost_hodnota_zakl.getDirty()) {
        this.$refs.zost_hodnota_zakl.setDirty(false);
        this.$refs.zost_hodnota_perc.loadData();
        this.$refs.zost_hodnota_s_dph.loadData();
        this.formDirty = true;
      }
    },
    zostHodnotaSDphValueChanged() {
      if (this.$refs.zost_hodnota_s_dph.getDirty()) {
        this.$refs.zost_hodnota_s_dph.setDirty(false);
        this.$refs.zost_hodnota_perc.loadData();
        this.$refs.zost_hodnota_zakl.loadData();
        this.formDirty = true;
      }
    },
    reload() {
      this.loadPoplatyTitulky()
        .then(async () => await this.loadVarianty())
        .then(() => (this.produktFormReloaded = true))
        .then(() => {
          if (this.kalkulaciaItems.length === 0) {
            this.formDirty = true;
          }
          this.$emit('initLoaded');
        });
    },
    async loadVarianty() {
      this.toggleDefaultLoadingDialog(true);
      return await protectedAxios
        .get(
          `kalk/varianty?newId=${this.pripad?.newId}&CisloPredmetu=${this.cisloPredmetu}&CisloPlz=${this.cisloPlz}&IdProduktu=${this.idProduktu}&JeOlfs=${this.jeOlfs}`
        )
        .then(res => {
          this.getKalkItemsFromResponse(res.data);
        })
        .finally(() => {
          this.toggleDefaultLoadingDialog(false);
        });
    },
    loadPoplatyTitulky() {
      return protectedAxios.get(`produkty/${this.idProduktu}/poplatkytitulky`).then(res => {
        this.poplatkyTitulky = res.data;
        if (res.data.filter(d => d.typ === 'sp_popl').length > 0) {
          this.sp_popl = res.data.filter(d => d.typ === 'sp_popl')[0];
        }
        if (res.data.filter(d => d.typ === 'ukon_popl').length > 0) {
          this.ukon_popl = res.data.filter(d => d.typ === 'ukon_popl')[0];
        }
        if (res.data.filter(d => d.typ === 'zv_spl_koniec').length > 0) {
          this.zv_spl_koniec = res.data.filter(d => d.typ === 'zv_spl_koniec')[0];
        }
        if (res.data.filter(d => d.typ === 'zost_hodn').length > 0) {
          this.zost_hodn = res.data.filter(d => d.typ === 'zost_hodn')[0];
        }
      });
    },
    onVariantSelected(val) {
      protectedAxios
        .post(
          `kalk/varianty/${val.item.pkid}/selected`,
          {
            selected: val.value ? 1 : 0,
            cisloPlz: val.item.cislo_plz,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(() => {
          this.$emit('onVariantSelected');
        });
    },
    allVariantsSelected(val) {
      if (val) {
        this.selected = this.kalkulaciaItems.filter(k =>k.id_color == null || k.id_color !== 3);
      } else {
        this.selected = [];
      }
      if (this.selected.length === 0) this.checkAll = false;
      protectedAxios
        .post(
          `kalk/varianty/selected`,
          {
            NewId: this.pripad?.newId,
            CisloPredmetu: this.cisloPredmetu,
            IdProduktu: this.idProduktu,
            Selected: val ? 1 : 0,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(() => {
          this.$emit('onVariantSelected');
        });
    },
    getSelectedVariants() {
      return this.selected;
    },
    hasVariants() {
      return this.kalkulaciaItems.length > 0;
    },
    getNazovProduktu() {
      return this.nazovProduktu;
    },
    emitParameterChanged() {
      this.$emit('parameterChanged', {
        cisloPlz: this.cisloPlz,
      });
    },
    async spustiKalkulaciu(idDodavatelZmena = -1) {
      if (this.potrebujeKalkulaciu()) {
        if(idDodavatelZmena > -1){
          return await protectedAxios
          .post(
            `kalk/zmena-dodavatel`,
            {
              cisloPlz: this.cisloPlz,
              idDodavatela: idDodavatelZmena,
              newId: this.pripad?.newId,
              cisloPredmetu: this.pripad.cisloPredmetu,
            },
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          .then(async res => {
            if (res.data.error == 0){
              return await this.kalkuluj(true);
            }else{
              if(res.data.errorText?.length > 0){
                eventBus.$emit('snack-error', res.data.errorText);
                return Promise.resolve(false);
              }
              return await protectedAxios.post(`controls/resetCheckCache`,{
                newId: this.pripad.newId,
              },{
                headers: {
                  'Content-Type': 'application/json',
                },
              }
              ).then(_ => {
                if(_.data?.length)
                  console.warn(_.data);
                return Promise.resolve(true);
              })
              // return this.kalkuluj();
            } 
          });
        }else{
          return await this.kalkuluj();
        }
      } else {
        return Promise.resolve(true);
      }
    },
    async kalkuluj(zmenaDodavatela = false){
      return await protectedAxios
          .post(
            `kalk`,
            {
              cisloPlz: this.cisloPlz,
              newId: this.pripad.newId,
              cisloPredmetu: this.cisloPredmetu,
              idProduktu: this.idProduktu,
              zmenaDodavatela: zmenaDodavatela ?? false
            },
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          .then(res => {
            if (res.data?.error_text?.length > 0) {
              eventBus.$emit('snack-error', res.data.error_text);
              this.$emit('produktValid', res.data.error_text);
            }
            this.$emit('updateCisloPlz',res.data.cisloPlz)
            return res;
          });
    },
    async nacitaniePoKalkulacii(){
      this.toggleDefaultLoadingDialog(true);
      return await protectedAxios
          .post(
            `kalk/nacianie-po-kalkulacii`,
            {
              cisloPlz: this.cisloPlz,
              newId: this.pripad?.newId,
              cisloPredmetu: this.cisloPredmetu,
              idProduktu: this.idProduktu,
              jeOlfs: this.jeOlfs
            },
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          .then(res => {
             this.getKalkItemsFromResponse(res.data);
            return res;
          })
          .finally(() => {
            this.toggleDefaultLoadingDialog(false);
          });
    },
    // kalkulujBezZmenySplatky(){
    //   return protectedAxios
    //       .post(
    //         `kalk/prepocet-lur-bez-zmeny-splatky`,
    //         {
    //           cisloPlz: this.cisloPlz,
    //           newId: this.pripad?.newId,
    //           cisloPredmetu: this.cisloPredmetu,
    //           idProduktu: this.idProduktu,
    //         },
    //         {
    //           headers: {
    //             'Content-Type': 'application/json',
    //           },
    //         }
    //       )
    //       .then(async res => {
    //         if (res.data.text?.length > 0) eventBus.$emit('snack-error', res.data.text);
    //         await this.$refs.zisk_zakl?.loadData()
    //         await this.$refs.ignorovat_prirazky?.loadData();
    //         this.getKalkItemsFromResponse(res.data.varianty);
    //         return res;
    //       });
    // },
    potrebujeKalkulaciu() {
      return this.formDirty || this.kalkulaciaItems.length === 0;
    },
    setDirty(dirty) {
      this.formDirty = dirty;
    },
    getKalkItemsFromResponse(varianty) {
     this.formDirty = false;
      if (varianty) {
        if (varianty.length > 0) {
          this.headers = [];
          if(this.jeOlfs){
            this.headers.push(...this.headersOLFS);
            
            if (varianty[0].zobraz_zlavu === 0) {
              this.headers = this.headers.filter(h => h.value !== 'zlava_zo_splatky');
              this.headers = this.headers.filter(h => h.value !== 'vynosovost_perc');
              this.headers = this.headers.filter(h => h.value !== 'vynos');
            }
          }else{
            this.headers.push(...this.headersGlobal);
            if (varianty[0].zobraz_sp_popl === 0) {
              this.headers = this.headers.filter(h => h.value !== 'sp_popl_s_dph');
              this.headers = this.headers.filter(h => h.value !== 'sp_popl_bez_dph');
            }
            if (varianty[0].zobraz_rpmn === 0) {
              this.headers = this.headers.filter(h => h.value !== 'rpmn');
            }

            if (varianty[0].zost_hodnota_s_dph && varianty[0].zh_zv_spl_koniec_podla_variantov) {
              this.headers.find(h => h.value === 'zost_hodnota_s_dph').align = this.dph
                ? ''
                : ' d-none';
            }
            if (varianty[0].zv_spl_koniec_s_dph && varianty[0].zh_zv_spl_koniec_podla_variantov) {
              this.headers.find(h => h.value === 'zv_spl_koniec_s_dph').align = this.dph
                ? ''
                : ' d-none';
            }
            if (varianty[0].zost_hodnota_bez_dph && varianty[0].zh_zv_spl_koniec_podla_variantov) {
              this.headers.find(h => h.value === 'zost_hodnota_bez_dph').align = !this.dph
                ? ''
                : ' d-none';
            }
            if (varianty[0].zv_spl_koniec_bez_dph && varianty[0].zh_zv_spl_koniec_podla_variantov) {
              this.headers.find(h => h.value === 'zv_spl_koniec_bez_dph').align = !this.dph
                ? ''
                : ' d-none';
            }
            if (varianty[0].zobraz_zisk === 0) {
              this.headers = this.headers.filter(h => h.value !== 'pom_zisk');
            }
          }

          if (varianty[0].zobraz_klientsky_urok === 0) {
              this.headers = this.headers.filter(h => h.value !== 'klientsky_urok');
            }
            if (varianty[0].zobraz_pozad_cisty_prijem === 0) {
              this.headers = this.headers.filter(h => h.value !== 'pozad_cisty_prijem');
            }
            
            if (this.jePrihlaseny === false) {
              this.headers = this.headers.filter(h => h.value !== 'id_color');
            }else{
              if (varianty[0].zobraz_semafor === 0) {
                this.headers = this.headers.filter(h => h.value !== 'id_color');
              }
            }
        }

        if(this.isMobile)
          this.headers.find(h => h.value === 'splatka_s_dph').text = 'Bez poistenia s DPH';
        
        const chybnyVariant = varianty.find((variant) => variant.odplata_text != null && variant.odplata_text != '' );
        if(chybnyVariant){
              this.odplataError = chybnyVariant?.odplata_text ?? '';
              return;
          }

        if(varianty[0].cislo_plz != null && varianty[0].cislo_plz != ''){
          for (let i = 0; i < varianty.length; i++) {
            let variant = varianty[i];
            variant.pom_zisk = this.zisk + (!!variant.zisk_zmena || variant.zisk_zmena == 0  ? variant.zisk_zmena : variant.zisk_prirazka);
          }
          this.kalkulaciaItems = varianty;
          this.selected = this.kalkulaciaItems.filter(s => s.selected === 1);
          if (
            this.kalkulaciaItems.length > 0 &&
            this.selected.length == this.kalkulaciaItems.length
          ) {
            this.checkAll = true;
          }
          if (this.kalkulaciaItems.length > 0) this.checkAllVisible = true;
        }
      }
      this.$emit("loadedVarianty");
    },
    visiblePoplatkyHeader(value, typ) {
      if (this.$refs[value + '_' + typ]) {
        this.poplatkyVisible[value][typ] = this.$refs[value + '_' + typ].l_visible
          ? this.$refs[value + '_' + typ].l_visible
          : false;
        this.poplatkyVisible[value][typ + '_loaded'] = true;
      }
    },
    visibleParameterKalkulacie(type, val){
      if(this.$refs[type]){
        this.parametreVisible[type] = this.$refs[type].l_visible
      }else{
        this.parametreVisible[type] = true;
      }
    },
    async onChangeZiskZakl(value, item) {
      let arrayChangedVarianty =[];
      for (let i = 0; i < this.kalkulaciaItems.length; i++) {
        let variant = this.kalkulaciaItems[i];
        if (variant.akontacia == item.akontacia) {
          variant.zisk_zmena = parseFloat(value) - this.zisk;
          variant.pom_zisk = this.zisk + (!!variant.zisk_zmena || variant.zisk_zmena == 0  ? variant.zisk_zmena : variant.zisk_prirazka);
          arrayChangedVarianty.push(variant)
        }
      }
      await this.saveChangedVarianty(arrayChangedVarianty);
       
    },
    async saveChangedVarianty(changedVarianty){
      await protectedAxios
          .post(
            `kalk/changeZiskVarianty`,
            {
              NewId: this.pripad.newId,
              varianty: changedVarianty,
            },
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          .then(res => {
            if (res.data?.length > 0) eventBus.$emit('snack-error', res.data);
            this.posliProduktFormDirty(true)
          }).catch((e)=>{
            console.error(e);
            this.posliProduktFormDirty(true)

          });     
    },
    posliProduktFormDirty(val) {
      this.$emit('produktFormDirty', val);
    },
    ziskLoaded(val) {
      if (val == null) return;
      this.zisk = parseFloat(val);
      if (this.kalkulaciaItems.length) {
        for (let i = 0; i < this.kalkulaciaItems.length; i++) {
          let variant = this.kalkulaciaItems[i];
          variant.pom_zisk = this.zisk + (!!variant.zisk_zmena || variant.zisk_zmena == 0  ? variant.zisk_zmena : variant.zisk_prirazka);
        }
      }
    },
    variantZiskError(errorText){
      let dialog = {
          persistent: true,
          header: `<span class="negative500 f16">Chyba</span>`,
          text: `<span class="f16 negative500"> ${errorText} </span>`,
          closeIcon: {
            value: true,
            func: null,
          },
          primaryBtn: {
            text: `Zavrieť`,
            func: null,
          },
        };

        return new Promise((res, rej) => {
          dialog.primaryBtn.func = () => {
            this.posliProduktFormDirty(true)
            this.closeDialog();
            res(true);
          };
          dialog.closeIcon.func = () => {
            this.posliProduktFormDirty(true)
            this.closeDialog();
            res(true);
          };
          this.openDialog(dialog);       
        })
    },
    async changeIgnorovatPrirazky(val){
      this.ignotovat_prirazky = val == 1 ? true : false;
      let arrayChangedVarianty =[];
      if (this.kalkulaciaItems.length) {
        for (let i = 0; i < this.kalkulaciaItems.length; i++) {
        let variant = this.kalkulaciaItems[i];
        if(val){
          variant.zisk_zmena = 0;
        }else{
          variant.zisk_zmena = null;
        }
        variant.pom_zisk = this.zisk + (!!variant.zisk_zmena || variant.zisk_zmena == 0  ? variant.zisk_zmena : variant.zisk_prirazka);
        arrayChangedVarianty.push(variant)
      }
      await this.saveChangedVarianty(arrayChangedVarianty).then(async _ => await this.loadVarianty());
      }
    },
    transformKalkulaciaItemValue(item, value) {
      if(item == 'rocny_najazd'){
        return value;
      }
      if (item == 'dlzka_leasingu') {
        return value >= 0 ? value.getTenor() : null
      } else if (item == 'klientsky_urok' || item == 'rpmn' ||item == 'akontacia' || item == 'vynosovost_perc') {
        return value >= 0 ? value.toPercentString(2) : '0,00%' 
      } else {
        return value >= 0 ? value.toEurString() : null
      }
    },
    checkMobileItem(item) {
      if (this.pripad.predmetZamknuty || !this.isCalculating) {
        item.selected = !item.selected
        if (item.selected) {
          this.selected.push(item);
        } else {
          this.selected = this.selected.filter(i => i !== item);
        }
        this.onVariantSelected({ item: item, value: item.selected });
      }
    },
    async onChangeZlavaZakl(zlava, item){
      const currentZlava = item?.zlava_zo_splatky;
      if (zlava == null || ( currentZlava == zlava)) {
        return Promise.resolve(true);
      }

      this.zlavaChangePending = true;
      this.toggleDefaultLoadingDialog(true, 'Prebieha ukladanie dát, prosím počkajte ...');
      return protectedAxios
        .post(
            `kalk/setZlava`,
            {
              NewId: this.pripad.newId,
              CisloPlz: this.cisloPlz,
              Zlava: zlava,
            },
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          .then(async res => {
            if(res.data?.error == 200){
              if(item) item.zlava_zo_splatky = zlava;
              await this.loadVarianty();
              return true;
            }

            eventBus.$emit('snack-error', res.data?.errorText || 'Pri ukladaní zľavy nastala chyba.');
            return false;
          }).catch((e)=>{
            console.error(e);
            eventBus.$emit('snack-error', 'Pri ukladaní zľavy nastala chyba.');
            return false;
          }).finally(() => {
            this.toggleDefaultLoadingDialog(false);
            this.zlavaChangePending = false;
          });     
    },
  },
  mounted() {
    this.reload();
  },
};
</script>
